import constants from 'constants/index'

const isSupplier = (company) =>
  company?.kind === constants.preRegistrations.SUPPLIER_KIND

export default isSupplier
